import { render, staticRenderFns } from "./MdtPhoneNumberInput.vue?vue&type=template&id=038f11b2&scoped=true"
import script from "./MdtPhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./MdtPhoneNumberInput.vue?vue&type=script&lang=js"
import style0 from "./MdtPhoneNumberInput.vue?vue&type=style&index=0&id=038f11b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038f11b2",
  null
  
)

export default component.exports